var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.35 24C11.35 25.0217 10.5217 25.85 9.5 25.85C8.47827 25.85 7.65 25.0217 7.65 24C7.65 22.9783 8.47827 22.15 9.5 22.15C10.5217 22.15 11.35 22.9783 11.35 24Z",
    fill: "#A69797",
    stroke: "#A69797",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.35 24C22.35 25.0217 21.5217 25.85 20.5 25.85C19.4783 25.85 18.65 25.0217 18.65 24C18.65 22.9783 19.4783 22.15 20.5 22.15C21.5217 22.15 22.35 22.9783 22.35 24Z",
    fill: "#A69797",
    stroke: "#A69797",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78187 2.66351L4.78188 2.66351L4.78165 2.66233C4.73657 2.43144 4.61515 2.22304 4.43694 2.07414C4.25901 1.92546 4.03583 1.84574 3.80603 1.85018H1.36362C0.803814 1.85018 0.35 2.30399 0.35 2.8638C0.35 3.4236 0.803813 3.87742 1.36362 3.87742H3.00537L6.14085 20.337L6.14098 20.3377C6.18606 20.5686 6.30747 20.777 6.48568 20.9259C6.66363 21.0745 6.88683 21.1543 7.11664 21.1498H21.1354C21.6952 21.1498 22.149 20.696 22.149 20.1362C22.149 19.5764 21.6952 19.1226 21.1354 19.1226H7.91655L7.29739 15.9681H21.9972C22.2241 15.9734 22.445 15.8966 22.6225 15.752C22.8004 15.6071 22.9236 15.4033 22.9725 15.1761L22.9726 15.1757L24.6263 7.4036C24.6263 7.40346 24.6264 7.40333 24.6264 7.4032C24.6586 7.25381 24.6578 7.09877 24.6241 6.94973C24.5903 6.80055 24.5243 6.66091 24.4306 6.54156C24.3369 6.42218 24.218 6.32615 24.0824 6.26127C23.9475 6.19666 23.7999 6.16477 23.651 6.16828H5.43703L4.78187 2.66351ZM22.4341 8.19552L21.216 13.9409H6.92487L5.82468 8.19552H22.4341Z",
    fill: "#A69797",
    stroke: "#A69797",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartMobile);
export default __webpack_public_path__ + "static/media/cart-mobile.3486bea3a3cfd33ccd7e784e69220f1e.svg";
export { ForwardRef as ReactComponent };